// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"vendor-badge_shadow__2i3f6","badge":"vendor-badge_badge__wGDm3"};